import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

const DELEGATES_KEY = 'delegates';

export function useDelegates(pageNumber = 1, pageSize = 50, search = '') {
  return useQuery({
    queryKey: [DELEGATES_KEY, pageNumber, pageSize, search],
    queryFn: async () => {
      const { data } = await api.get('/delegates', { 
        params: { pageNumber, pageSize, search } 
      });
      return data; // نفترض أن الـ API يعيد البيانات بهذا الشكل
    }
  });
}

export function useCreateDelegate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => api.post('/delegates', data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [DELEGATES_KEY] })
  });
}
